export default "__VITE_ASSET__f17268e6__"